import React, { useState } from "react";
import "./CollectorForgetPassword.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import img1 from "../../../assest/img2.jpg";
import img2 from "../../../assest/img3.jpg";
import img3 from "../../../assest/img4.jpg";
import img4 from "../../../assest/user3.png";
import img5 from "../../../assest/ips.png";
import {
  forgotPasswordCollector,
  resetCollectorPassword,
} from "../../../api/collectorApi";

function CollectorForgetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "";

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // OTP modal
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Password modal
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  /* ==========================
      SEND OTP
  ========================== */
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await forgotPasswordCollector({ email });

      if (res.data?.success) {
        setShowOtpModal(true);
      } else {
        setError(res.data?.message || "Failed to send OTP");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  /* ==========================
      OTP HANDLERS
  ========================== */
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // auto focus next
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    // backspace → previous
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  /* ==========================
      VERIFY OTP
  ========================== */
  const handleVerifyOtp = () => {
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      setError("Please enter valid 6 digit OTP");
      return;
    }

    setError("");
    setShowOtpModal(false);
    setShowPasswordModal(true);
  };

  /* ==========================
      RESET PASSWORD
  ========================== */
  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setError("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await resetCollectorPassword({
        email,
        otp: otp.join(""),
        newPassword,
        confirmPassword,
      });

      if (res.data?.success) {
        alert("Password reset successfully");
        navigate("/");
      } else {
        setError(res.data?.message || "Reset failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="collector-login-page">
       <div id="rag-widget-mount"></div>
        <div className="collector-left">
              <div className="collector-header">
                       <div className="minister-section">
                         <div className="ministerrow">
                           <img src={img1} alt="Chief Minister" />
                           <p>
                             Shri Mohan Charan Majhi
                             <br />
                             <span>Hon’ble Chief Minister</span>
                           </p>
                         </div>
                         <div className="minister-row">
                           <div className="minister">
                             <img src={img2} alt="Deputy Minister" />
                             <p>
                               Shri Kanak Vardhan Singh Deo
                               <br />
                               <span>Hon’ble Deputy Chief Minister</span>
                             </p>
                           </div>
                           <div className="minister">
                             <img src={img3} alt="Deputy Minister" />
                             <p>
                               Smt. Pravati Parida
                               <br />
                               <span>Hon’ble Deputy Chief Minister</span>
                             </p>
                           </div>
                         </div>
                       </div>
                     </div>
             
                  
                     <div className="collector-info">
                       <div className="officer">
                         <img src={img4} alt="Collector" />
                         <p>
                        {/* Shri Ashish Ishwar Patil, IAS */}
                           {/* <br /> */}
                           <span>Collector & District Magistrate</span>
                         </p>
                       </div>
                       <div className="officer">
                         <img src={img4} alt="SP" />
                         <p>
                          {/* Shri Abhinav Sonkar, IPS */}
                           {/* <br /> */}
                           <span>Superintendent of Police</span>
                         </p>
                       </div>
                     </div>
                     <div className="collector-title">
                       <h2>SAMADHAN</h2>
                  {/* <p>AI-Based Grievance Management System</p> */}
                </div>
              </div>
             <div className="collector-right">
        <div className="login-card">
        <h2>Forgot Password</h2>

        <form onSubmit={handleSendOtp}>
          <label>Email ID</label>
          <input type="email" value={email} readOnly />

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "SEND OTP"}
          </button>
        </form>

        <p className="back-login" onClick={() => navigate("/")}>
          Back to Login
        </p>
      </div>

      {/* ================= OTP MODAL ================= */}
      {showOtpModal && (
        <div className="CollectorForgetmodal-overlay">
          <div className="CollectorForgetmodal">
            <h3>Enter OTP</h3>
            <p>Enter 6 digit OTP sent to your registered mobile</p>

            <div className="CollectorForgetotp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) =>
                    handleOtpChange(e.target.value, index)
                  }
                  onKeyDown={(e) =>
                    handleOtpKeyDown(e, index)
                  }
                />
              ))}
            </div>

            {error && <p className="CollectorForgeterror">{error}</p>}

            <button onClick={handleVerifyOtp}>
              VERIFY OTP
            </button>
          </div>
        </div>
      )}

     {/* ================= PASSWORD MODAL ================= */}
{showPasswordModal && (
  <div className="CollectorForgetmodal-overlay">
    <div className="CollectorForgetmodal">
      <h3>Reset Password</h3>

      {/* New Password */}
      <div className="CollectorForgetpassword-field">
        <input
          type={showNewPassword ? "text" : "password"}
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <span
          className="CollectorForgeteye-icon"
          onClick={() => setShowNewPassword(!showNewPassword)}
        >
          {showNewPassword ? <FiEyeOff /> : <FiEye />}
        </span>
      </div>

      {/* Confirm Password */}
      <div className="CollectorForgetpassword-field">
        <input
          type={showConfirmPassword ? "text" : "password"}
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <span
          className="CollectorForgeteye-icon"
          onClick={() =>
            setShowConfirmPassword(!showConfirmPassword)
          }
        >
          {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
        </span>
      </div>

      {error && <p className="CollectorForgeterror">{error}</p>}

      <button onClick={handleResetPassword} disabled={loading}>
        {loading ? "Resetting..." : "RESET PASSWORD"}
      </button>
    </div>
  </div>
)}
</div>
    </div>
  );
}

export default CollectorForgetPassword;
